import { PropsWithChildren } from 'react';
import { useModal } from '@ebay/nice-modal-react';
import { useIsMounted } from '@toss/react';
import cns from 'classnames';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { useIsomorphicViewportDevice } from '@zep/react';
import { Button } from '@zep/ui';
import { isApp, isMobile } from '@zep/utils';
import { ManagePageType, SubLayoutButton } from '../../../types';
import { StorePageType } from '../../../types';
import { UploadTypeSelectionModal } from '../../service';
import S from './SubLayout.module.scss';
export const SubLayout: React.FC<SubLayoutProps> = ({
  leftButtons,
  rightButtons,
  currentPage,
  children
}: SubLayoutProps) => {
  const uploadModal = useModal(UploadTypeSelectionModal);
  const {
    t
  } = useTranslation(['store']);
  const {
    isPortraitMobile,
    isTablet,
    isMobile: isMobileView
  } = useIsomorphicViewportDevice();
  const isMounted = useIsMounted();
  const handleUploadAssetModalShow = () => {
    logger.track('store_upload_btn');
    uploadModal.show();
  };
  return <main id="store-sublayout" data-sentry-component="SubLayout" data-sentry-source-file="SubLayout.tsx">
      <div className={cns(S.layout_header, {
      [S.app_header]: isApp()
    })}>
        <div className={S.top_nav}>
          <ul className={S.tab_list}>
            {leftButtons.map(item => <li key={item.name} className={cns(S.tab_list_item, {
            [S.active_item]: currentPage === item.name
          })}>
                <Link href={item.link} prefetch={false}>
                  {item.pageName}
                </Link>
              </li>)}
          </ul>
          {isPortraitMobile && <span className={S.contour_line_x}></span>}
          {!isTablet && !isMobileView ? rightButtons && <div className={S.me_tab_item}>
                {rightButtons.map(item => <Link key={item.name} href={item.link} className={cns(S.tab_item, {
            [S.active_item]: currentPage === item.name
          })} prefetch={false}>
                    {item.pageName}
                  </Link>)}
              </div> : <div className={S.mobile_like_item}>
              <Link href="/store/save?type=like" className={S.tab_item} prefetch={false}>
                <img width={14} height={14} src={`/images/light/assetStore/${currentPage !== 'like' ? 'favorite_border-gray' : 'favorite_filled-primary'}.svg`} alt="favorite" />
                <span>{t('store:store_asset_liked_list')}</span>
              </Link>
              <Link href="/store/save?type=purchased" className={S.tab_item} prefetch={false}>
                <img width={14} height={14} src={`/images/light/assetStore/${currentPage !== 'purchased' ? 'download-gray500' : 'download-primary'}.svg`} alt="purchased" />
                <span>{t('store:store_asset_purchased_list')}</span>
              </Link>
            </div>}

          {isMounted && !isMobile() && <Button size={'md'} onClick={handleUploadAssetModalShow}>
              {t('store:store_asset_upload')}
            </Button>}
        </div>
      </div>
      <div className={S.layout_content}>
        <div className={S.inner}>{children}</div>
      </div>
    </main>;
};

/**
 * 에셋 스토어에서 전반적으로 사용하는 레이아웃(헤더)의 프로퍼티
 */
export type SubLayoutProps = PropsWithChildren<{
  currentPage?: StorePageType | ManagePageType;
  leftButtons: Array<SubLayoutButton>;
  rightButtons?: Array<SubLayoutButton>;
}>;